import axios from 'axios';
import * as actionTypes from '../actions/types';

const baseUrl = process.env.NODE_ENV === 'development' ? 
    process.env.REACT_APP_DEV_API_BASE_URL : process.env.REACT_APP_PROD_API_BASE_URL;

export const addInterestedInYou = (firstMoveProfileId, secondMoveProfileId, profile) => async (dispatch) => {
    var data = { firstMoveProfileId, secondMoveProfileId };
    await axios.post(`${baseUrl}/api/couples`, data)
        .then(res => {
            dispatch({type: actionTypes.ADD_INTERESTED_IN_YOU, payload: res.data});
        })
        .catch(err => {
            dispatch({type: actionTypes.ADD_INTERESTED_IN_YOU, payload: err});
        });
}

export const fetchCouples = id => async dispatch => {
    await axios.get(`${baseUrl}/api/couples/${id}`)
        .then(res => {
            dispatch({type: actionTypes.SHOW_INTERESTED_IN_YOU, payload: res.data});
        })
        .catch(err => {
            dispatch({type: actionTypes.SHOW_INTERESTED_IN_YOU, payload: err});
        });
}

export const fetchMessageRoomMessages = profileName => async dispatch => {
    await axios.get(`${baseUrl}/api/messages/${profileName}`)
        .then(res => {
            dispatch({type: actionTypes.FETCH_MESSAGE_ROOM_MESSAGES, payload: res.data})
        })
}

export const unmatchCouple = (coupleId, profileId) => async (dispatch, getState) => {
    const data = { coupleId, profileId }
    await axios.post(`${baseUrl}/api/couples/unmatch`, data)
        .then(res => {
            dispatch({type: actionTypes.UNMATCH_COUPLE, payload: res.data});
        })
        .catch(() => {
            dispatch({type: actionTypes.UNMATCH_COUPLE, payload: getState().interestedInYou});
        });
}

export const sendMessage = message => async dispatch => {
    await axios.post(`${baseUrl}/api/messages`, message)
        .then(() => {
            dispatch({type: actionTypes.MESSAGE_SENT, payload: message});
        })
}